module.exports = __webpack_public_path__ + "static/img/yikang3.fd09ef48.png";